import React from "react";
import { DocumentDuplicateIcon as DocumentDuplicateIconSolid } from "@heroicons/react/24/solid";
import { DocumentDuplicateIcon as DocumentDuplicateIconOutline } from "@heroicons/react/24/outline";
import { twMerge } from "tailwind-merge";
import toast from "react-hot-toast";

type CopyButtonProps = {
  text: string;
  className?: string;
  iconClassName: string;
  succesMessage: string;
};
const CopyButton = ({ text, className, iconClassName, succesMessage }: CopyButtonProps) => {
  const [copied, setCopied] = React.useState(false);

  const copyToClipboard = () => {
    if (text) {
      navigator.clipboard.writeText(text);
      setCopied(true);
      toast.success(succesMessage);

      setTimeout(() => setCopied(false), 1000);
    }
  };

  return (
    <div>
      {copied ? (
        <div className={`relative flex items-center ${className}`}>
          <DocumentDuplicateIconSolid
            className={twMerge(
              `h-5 w-5 cursor-pointer stroke-2 ${iconClassName}`,
              !iconClassName && "text-slate-900 hover:text-slate-600"
            )}
            onClick={copyToClipboard}
          />
        </div>
      ) : (
        <div className={`relative flex items-center ${className}`}>
          <DocumentDuplicateIconOutline
            className={twMerge(
              `h-5 w-5 cursor-pointer stroke-2 ${iconClassName}`,
              !iconClassName && "text-slate-500 hover:text-slate-600"
            )}
            onClick={copyToClipboard}
          />
        </div>
      )}
    </div>
  );
};

export default CopyButton;
